import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.textBackground.light,
    marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(4, 5, 2.5, 5),
  },
  salesforceWrapper: {
    padding: theme.spacing(0, 1),
  },
  footerWrapper: {
    paddingRight: `theme.spacing(2.75)px !important`, //need to override the default padding
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: theme.spacing(5),
    gap: theme.spacing(3),
  },
  customFooter: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
  },
}))
